<template>
  <div class="article-list">
    <h1
      v-if="
        initialdata &&
        initialdata.clear_filter_url &&
        !articleDataset.filter_title &&
        !articleDataset.articles_title
      "
      style="text-align: center"
      class="h1implantation"
    >
      {{ initialdata.clear_filter_url.replace(/[^a-zA-Z0-9 ]/g, ' ').toUpperCase() }}
    </h1>
    <div ref="tags" class="tags">
      <tags :article-dataset="articleDataset"></tags>
      <loadingoverlay :loadingtext="articleDataset.filter_data.loading_text"></loadingoverlay>
    </div>
    <div v-if="articleDataset.is_one_filter_selected" class="article-content">
      <h1 v-if="articleDataset.filter_title">{{ articleDataset.filter_title }}</h1>
      <p v-if="articleDataset.filter_description">{{ articleDataset.filter_description }}</p>
    </div>
    <div v-else class="article-content">
      <h1 v-if="articleDataset.articles_title">{{ articleDataset.articles_title }}</h1>
      <p v-if="articleDataset.articles_description">{{ articleDataset.articles_description }}</p>
    </div>
    <div class="container articles-list">
      <div class="row">
        <div class="articles-list-wrapper">
          <grid :article-dataset="articleDataset"></grid>
          <loadmore :article-dataset="articleDataset"></loadmore>
          <loadingoverlay :loadingtext="articleDataset.filter_data.loading_text"></loadingoverlay>
        </div>
      </div>
    </div>

    <a
      class="scroll-to-top"
      :class="{ 'is-active': active }"
      :scroll="handleScroll"
      aria-label="Scroll to top"
      @click="scrollToTop()"
    >
      <svg
        id="mdi-chevron-up-circle-outline"
        class="icontop"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M7.4,15.4L12,10.8L16.6,15.4L18,14L12,8L6,14L7.4,15.4Z"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import Tags from './tags.vue';
import Grid from './grid.vue';
import LoadMore from './load-more.vue';
import LoadingOverlay from '../loading-overlay/loading-overlay.vue';
import 'whatwg-fetch';
import debounce from 'lodash/debounce';
import { animate } from 'animejs';

export default {
  name: 'article-list',
  components: {
    Tags,
    Grid,
    loadmore: LoadMore,
    loadingoverlay: LoadingOverlay,
  },
  props: {
    initialdata: { type: Object, required: true },
  },
  data() {
    return {
      articleDataset: this.initialdata,
      stuck: false,
      active: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', debounce(this.handleScroll, 160));
    if (window.eventBus) {
      window.eventBus.$on('stickyelement.stuck', () => {
        if (!this.stuck) {
          this.setHeight();
          this.stuck = true;
        }
      });

      window.eventBus.$on('stickyelement.unstuck', () => {
        if (this.stuck) {
          this.stuck = false;
          this.tagsHeight = '0px';
        }
      });
    }
  },
  methods: {
    scrollToTop() {
      animate([document.documentElement, document.body], {
        scrollTop: 0,
        duration: 500,
        delay: 100,
        ease: 'outSine',
        round: 1, // round the scroll value
      });
    },
    handleScroll() {
      if (window.pageYOffset > 308) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
    getData(apiUrl, pushState = false) {
      /* istanbul ignore next */
      const checkStatus = (response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        }

        const error = new Error(response.statusText);
        error.response = response;
        throw error;
      };

      /* istanbul ignore next */
      const parseJSON = (response) => response.json();

      /* istanbul ignore next */
      if (window.eventBus) {
        window.eventBus.$emit('overlay.on');
      }

      /* istanbul ignore next */
      fetch(apiUrl)
        .then(checkStatus)
        .then(parseJSON)
        .then((data) => {
          this.articleDataset = data;
          this.pushUrl(pushState);

          if (window.eventBus) {
            window.eventBus.$emit('overlay.off');
          }
        })
        .catch((error) => {
          console.error(`request failed [${apiUrl}]`, error);
          if (window.eventBus) {
            window.eventBus.$emit('overlay.off');
          }

          this.pushUrl(pushState);
        });
    },

    pushUrl(url) {
      if (url == null || typeof url !== 'string') {
        return;
      }
      const trimmed = url.trim();
      if (!trimmed) {
        return;
      }
      const isAbsoluteUrl = /^https?:\/\//i.test(trimmed);
      const looksLikeQueryString =
        !trimmed.startsWith('/') && !isAbsoluteUrl && trimmed.includes('=');

      if (looksLikeQueryString || trimmed.toLowerCase().includes('tags=')) {
        const queryurl = trimmed.startsWith('?') ? trimmed : '?' + trimmed;
        history.pushState({}, document.title, queryurl);
        return;
      }

      let path = trimmed;
      const x = path.slice(-1);
      if (x !== '/') {
        path = path + '/';
      }
      history.pushState({}, document.title, path);
    },

    setHeight() {
      this.tagsHeight = `${this.getHeight(this.$refs.tags)}px`;
    },

    getHeight(el) {
      let height = el.offsetHeight;
      const style = window.getComputedStyle(el);

      height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
      return height;
    },
  },
};
</script>
